import posthog from "posthog-js";
import type pino from "pino";
import { readStatisticsConsent, type ConsentStatus } from "./consent";

export function initPostHog(logger: pino.Logger): void {
  if (typeof window === "undefined" || posthog.__loaded) return;

  const { VITE_POSTHOG_HOST, VITE_POSTHOG_PROJECT_TOKEN } = import.meta.env;
  if (!VITE_POSTHOG_HOST || !VITE_POSTHOG_PROJECT_TOKEN) {
    logger.warn("PostHog not set");
    return;
  }

  const bootstrapId = window.__POSTHOG_BOOTSTRAP_DISTINCT_ID__;
  delete window.__POSTHOG_BOOTSTRAP_DISTINCT_ID__;
  const granted = readStatisticsConsent() === "granted";

  posthog.init(VITE_POSTHOG_PROJECT_TOKEN, {
    api_host: VITE_POSTHOG_HOST,
    ui_host: "https://eu.posthog.com",
    defaults: "2026-05-30",
    person_profiles: "identified_only",
    capture_pageview: "history_change",
    capture_pageleave: true,
    capture_heatmaps: true,
    /// Nothing stored on the device until opt-in, cookieless counting on reject.
    /// https://posthog.com/tutorials/cookieless-tracking#if-you-want-to-show-a-cookie-banner
    cookieless_mode: "on_reject",
    secure_cookie: window.location.protocol === "https:",
    persistence_name: "aqora",
    opt_out_capturing_by_default: true,
    mask_all_text: true,
    mask_personal_data_properties: true,
    mask_all_element_attributes: true,
    tracing_headers: [window.location.hostname],
    ...(bootstrapId && granted && { bootstrap: { distinctID: bootstrapId } }),
  });
}

export function applyConsent(status: ConsentStatus): void {
  if (status === "pending") return;
  if (posthog.get_explicit_consent_status() === status) return;

  if (status === "granted") posthog.opt_in_capturing();
  else posthog.opt_out_capturing();
}

export { posthog };
